(function () {
    'use strict';

    var btn = document.getElementById('gtv-load-more');
    if (!btn || typeof gtvLoadMore === 'undefined') { return; }

    var grid   = document.getElementById('gtv-cat-posts');
    var busy   = false;
    var cfg    = gtvLoadMore;

    function setDone(text) {
        btn.disabled = true;
        btn.textContent = text;
    }

    btn.addEventListener('click', function () {
        if (busy || btn.disabled) { return; }
        busy = true;
        btn.classList.add('is-loading');

        var nextPage = parseInt(btn.dataset.page, 10) + 1;
        var body = new URLSearchParams();
        body.append('action', cfg.action);
        body.append('nonce', cfg.nonce);
        body.append('term', btn.dataset.term);
        body.append('page', nextPage);

        fetch(cfg.ajaxUrl, { method: 'POST', body: body, credentials: 'same-origin' })
            .then(function (r) { return r.json(); })
            .then(function (json) {
                if (!json.success) {
                    throw new Error((json.data && json.data.message) || 'Load failed');
                }
                var d = json.data;

                if (d.html) {
                    grid.insertAdjacentHTML('beforeend', d.html);
                }

                btn.dataset.page = d.page;

                if (!d.hasMore) {
                    setDone('No more posts');
                }

                busy = false;
                btn.classList.remove('is-loading');
            })
            .catch(function () {
                busy = false;
                btn.classList.remove('is-loading');
                setDone('Try again later');
            });
    });
})();